import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@rtls-environment/environment';
import { Result } from '@rtls/core/models/result.model';
import { Pagination } from '@rtls/core/models/rpc/pagination.model';
import { SearchOperation } from '@rtls/core/models/rpc/search-operation';
import { SearchQuery } from '@rtls/core/models/rpc/search-query';

import { RtlsModels } from '@rtls/core/models/rtls/rtls-models';
import { RtlsServiceDecorator } from '@rtls/core/models/rtls/rtls-service.decorator';
import { RtlsService } from '@rtls/core/models/rtls/rtls-service.model';
import { Tag } from '@rtls/core/models/tag/tag.model';
import { TenantService } from '@rtls/core/tenant/tenant.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class TagService extends RtlsServiceDecorator<Tag> {
	constructor(
		rtlsService: RtlsService<Tag>,
		private tenantService: TenantService,
	) {
		super(rtlsService.useModel(RtlsModels.Tags, environment.sensorsUrl));
	}

	public getTag(tagMac: Array<string>): Observable<Tag[]> {
		const pagination = Pagination.unlimited();
		return this.searchWithParams(
			new SearchQuery('mac', SearchOperation.IN, tagMac.join(',')),
			pagination,
			undefined,
			new HttpHeaders().append('X-Rtls-Tenant', this.tenantService.getActiveTenant() || ''),
		).pipe(map((result: Result<Tag>) => result.data));
	}
}
